import API_CLIENT from "../../utils/Api";
import { buildPayload } from "../../utils/helper";

export async function GetStoreBoxOrders(page) {
  return await API_CLIENT.get(`/store-box-orders?page=${page}`);
}
export const CreateStoreBoxOrders = async (payload) => {
  const sanitizedPayload = buildPayload(payload);
  return await API_CLIENT.post("/store-box-orders/", sanitizedPayload);
};
